import { Alert, Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, TwoSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { Link as LinkTo } from "react-router"
import { BackButton } from "../../../../../common/components/back_button"
import { useChecklistServicoAmbienteListaViewModel } from "../../viewModels/checklist_servico_lista_ambiente_view_model"
import { ChecklistServicoAmbienteModel } from "../../../domain/models/checklist_servico_ambiente"
import { CadastroChecklistServicoAmbienteModal } from "./components/cadastro_checklist_entrega_ambiente_modal"
import { CopiaChecklistServicoAmbienteModal } from "./components/copia_checklist_entrega_ambiente_modal"
import { GenerateChecklistServicoAmbienteColumns } from "./columns"


export const ChecklistServicoAmbienteLista = () => {
    const viewModel = useChecklistServicoAmbienteListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateChecklistServicoAmbienteColumns({
            hasObraChecklistServico: viewModel.selectedChecklistServico !== undefined && viewModel.selectedChecklistServico.hasObraChecklistServico,
            onActionEdit: viewModel.handleChecklistServicoAmbienteOpenState,
            onActionDelete: viewModel.handleChecklistServicoAmbienteDeleteOpenState,
            onActionCopia: viewModel.handleChecklistServicoAmbienteCopiaOpenState,
            onActionItens: viewModel.handleEditItens,
        });
    }, [
        viewModel.handleChecklistServicoAmbienteOpenState,
        viewModel.handleChecklistServicoAmbienteDeleteOpenState,
        viewModel.handleChecklistServicoAmbienteCopiaOpenState,
        viewModel.selectedChecklistServico,
        viewModel.handleEditItens,
    ]);

    return (
        <>
            <PageTopBar>
                <TwoSlotLayout

                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                {
                                    !(viewModel.selectedChecklistServico !== undefined
                                        && viewModel.selectedChecklistServico.hasObraChecklistServico) &&
                                    <PrimaryButton
                                        startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                        onClick={() => viewModel.handleChecklistServicoAmbienteOpenState(null, true)}>
                                        Novo Ambiente
                                    </PrimaryButton>
                                }

                            </div>

                            <div>
                                <BackButton onClick={viewModel.handleBack} />
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-6 flex-col py-5 px-4">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Link underline="hover" color="inherit" component={"span"}>
                        <LinkTo to="/ChecklistServico_lista">Checklist de Servico de Obras Lista</LinkTo>
                    </Link>
                    <Typography className="text-primary-green">
                        Ambiente Checklist de Servico
                    </Typography>
                </Breadcrumbs>

                <div className="flex flex-col gap-2">
                    <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">Ambiente Checklist de Serviço</h1>
                            <RefreshButton onClick={viewModel.handleReload} />
                        </div>

                        <div className="w-full justify-end flex gap-2">
                        </div>
                    </div>

                    <div className="flex gap-2 items-center w-full">
                        {/* iNFORMAÇÕES DO CHECKLIST DE SERVIÇO SELECIONADO */}
                        {
                            viewModel.selectedChecklistServico &&
                            <div className="w-full flex flex-col gap-0">
                                <div className="w-full flex flex-row items-center">
                                    <span className="text-black dark:text-white font-bold text-lg">
                                        {viewModel.selectedChecklistServico.codigo} | {viewModel.selectedChecklistServico.descricao}
                                    </span>
                                </div>
                                <div> </div>
                                {
                                    (viewModel.selectedChecklistServico.revisao && viewModel.selectedChecklistServico.revisao.length > 0) &&
                                    <span className="text-gray-600 dark:text-gray-300 font-bold text-base">
                                        Revisão: {viewModel.selectedChecklistServico.revisao}
                                    </span>
                                }
                                {
                                    viewModel.selectedChecklistServico.hasObraChecklistServico &&
                                    <div className="w-full mt-4">
                                        <Alert severity="error">
                                            Não é possível incluir ou excluir ambientes do check list, pois ele está vinculado à alguma obra.
                                        </Alert>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                descricao={viewModel.filters.descricao}
                                handleDescricaoChange={viewModel.handleDescricaoChange}
                                onClearFilters={viewModel.handleClearFilters}
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="Clientes_Lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ChecklistServicoAmbienteModel) => row.idChecklistServicoAmbiente}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.checklistServicoAmbienteLista}
                                    rowCount={viewModel.checklistServicoAmbienteLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idChecklistServicoAmbiente', 'acoes'],
                                    }}
                                    getRowHeight={() => 'auto'}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }
            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleChecklistServicoAmbienteDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarChecklistServicoAmbiente}
            />

            <CopiaChecklistServicoAmbienteModal
                open={viewModel.openCopiaModal}
                saving={viewModel.saving}
                selectedChecklistServicoAmbiente={viewModel.selectedChecklistServicoAmbiente}
                onClose={() => viewModel.handleChecklistServicoAmbienteCopiaOpenState(null, false)}
                onSubmit={viewModel.handleSubmitChecklistServicoAmbienteCopia}
            />

            <CadastroChecklistServicoAmbienteModal
                open={viewModel.openCadastroModal}
                saving={viewModel.saving}
                loading={viewModel.loading}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                selectedChecklistServicoAmbiente={viewModel.selectedChecklistServicoAmbiente}
                onClose={() => viewModel.handleChecklistServicoAmbienteOpenState(null, false)}
                onSubmit={viewModel.handleSubmitChecklistServicoAmbiente}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

        </>
    )
}


